import React, { useEffect, useState } from "react";
import { RotateCcw, Loader2 } from "lucide-react";

export const RESEND_SECONDS = 30;

// Resend button with a visible "Resend in 45s" pill + progress bar. `nonce` restarts the countdown (e.g. request_id).
export function ResendCountdown({ onResend, busy = false, seconds = RESEND_SECONDS, nonce, testId = "otp-resend" }) {
  const [left, setLeft] = useState(seconds);
  useEffect(() => { setLeft(seconds); }, [nonce, seconds]);
  useEffect(() => { if (left <= 0) return undefined; const t = setTimeout(() => setLeft((n) => n - 1), 1000); return () => clearTimeout(t); }, [left]);
  const pct = Math.max(0, Math.min(100, Math.round(((seconds - left) / seconds) * 100)));
  return (
    <div className="space-y-2" data-testid={`${testId}-wrap`}>
      <div className="flex items-center justify-between gap-3 text-sm">
        <span className="text-ink-soft">Didn't get the code?</span>
        {left > 0 ? (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-surface-100 px-3 py-1 text-xs font-semibold tabular-nums text-ink-soft ring-1 ring-surface-300" aria-live="polite" data-testid={`${testId}-countdown`}>
            <RotateCcw className="h-3 w-3" /> Resend in {left}s
          </span>
        ) : (
          <button type="button" onClick={onResend} disabled={busy} className="inline-flex items-center gap-1.5 rounded-full bg-brand-100 px-3 py-1 text-xs font-semibold text-brand-700 ring-1 ring-brand-200 hover:bg-brand-200 disabled:opacity-50" data-testid={testId}>
            {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <RotateCcw className="h-3 w-3" />} Resend code
          </button>
        )}
      </div>
      {left > 0 && <div className="h-1 w-full overflow-hidden rounded-full bg-surface-200"><div className="h-full bg-brand transition-[width] duration-1000 ease-linear" style={{ width: `${pct}%` }} data-testid={`${testId}-progress`} /></div>}
    </div>
  );
}
